// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  /* text-align: center; */
}
.dashboard-container {
  width: 100%;
  height: 100%;
  transition: all 1s ease;
  padding: 24px 12px;
  box-sizing: border-box;
}
.main-container {
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  transition: all 1s ease;
}
.topbar-container {
  flex: 1;
  width: 100vw;
}

.center-container {
  flex: 8;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
}
.leftsidebar-container {
  flex: 1;
}

.content-container {
  flex: 8;
}

.data-container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
}
.table-column-image {
  height: 100px;
  width: 100px;
  object-fit: contain;
}
.order-dash-container {
  display: flex;
  height: 100%;
  width: 100%;
  align-self: center;
  justify-self: center;
}
.order-dash-left-item {
  flex: 1;
  height: 100%;
  background-color: coral;
}
.order-dash-center-item {
  flex: 3;
  height: 100%;
  background-color: aquamarine;
}

.order-dash-right-item {
  flex: 1.5;
  height: 100%;
  background-color: cadetblue;
}

.inventory-table {
  overflow-x: hidden;
}

.inventory-table .table {
  overflow-x: scroll;
}

/* Fix for React Bootstrap v5 close button when using Bootstrap v4 CSS */
.btn-close {
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: #000;
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center/1em auto no-repeat;
  border: 0;
  border-radius: 0.25rem;
  opacity: 0.5;
}

.btn-close:hover {
  color: #000;
  text-decoration: none;
  opacity: 0.75;
}

.btn-close:focus {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  opacity: 1;
}

.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  user-select: none;
  opacity: 0.25;
}

.modal-header .btn-close {
  padding: 0.5rem 0.5rem;
  margin: -0.5rem -0.5rem -0.5rem auto;
}

/* Global card styling */
.card {
  box-shadow: none !important;
  border: 1px solid #e3ebf6 !important;
  border-radius: 12px !important;
}

/* Hide spin buttons / up & down arrows on number inputs */
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button,
.no-spinner::-webkit-outer-spin-button,
.no-spinner::-webkit-inner-spin-button,
.no-spinner input::-webkit-outer-spin-button,
.no-spinner input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  appearance: none !important;
  margin: 0 !important;
}

input[type="number"],
.no-spinner[type="number"],
.no-spinner input[type="number"] {
  -moz-appearance: textfield !important;
}


`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,OAAO;AACT;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,OAAO;EACP,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,OAAO;EACP,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,wEAAwE;AACxE;EACE,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,WAAW;EACX,yFAA2W;EAC3W,SAAS;EACT,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,kDAAkD;EAClD,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA,wBAAwB;AACxB;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA,0DAA0D;AAC1D;;;;;;EAME,mCAAmC;EACnC,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;;;EAGE,qCAAqC;AACvC","sourcesContent":[".App {\n  /* text-align: center; */\n}\n.dashboard-container {\n  width: 100%;\n  height: 100%;\n  transition: all 1s ease;\n  padding: 24px 12px;\n  box-sizing: border-box;\n}\n.main-container {\n  height: 100vh;\n  width: 100vw;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  transition: all 1s ease;\n}\n.topbar-container {\n  flex: 1;\n  width: 100vw;\n}\n\n.center-container {\n  flex: 8;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: row;\n}\n.leftsidebar-container {\n  flex: 1;\n}\n\n.content-container {\n  flex: 8;\n}\n\n.data-container {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n.table-column-image {\n  height: 100px;\n  width: 100px;\n  object-fit: contain;\n}\n.order-dash-container {\n  display: flex;\n  height: 100%;\n  width: 100%;\n  align-self: center;\n  justify-self: center;\n}\n.order-dash-left-item {\n  flex: 1;\n  height: 100%;\n  background-color: coral;\n}\n.order-dash-center-item {\n  flex: 3;\n  height: 100%;\n  background-color: aquamarine;\n}\n\n.order-dash-right-item {\n  flex: 1.5;\n  height: 100%;\n  background-color: cadetblue;\n}\n\n.inventory-table {\n  overflow-x: hidden;\n}\n\n.inventory-table .table {\n  overflow-x: scroll;\n}\n\n/* Fix for React Bootstrap v5 close button when using Bootstrap v4 CSS */\n.btn-close {\n  box-sizing: content-box;\n  width: 1em;\n  height: 1em;\n  padding: 0.25em 0.25em;\n  color: #000;\n  background: transparent url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000'%3e%3cpath d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/%3e%3c/svg%3e\") center/1em auto no-repeat;\n  border: 0;\n  border-radius: 0.25rem;\n  opacity: 0.5;\n}\n\n.btn-close:hover {\n  color: #000;\n  text-decoration: none;\n  opacity: 0.75;\n}\n\n.btn-close:focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n  opacity: 1;\n}\n\n.btn-close:disabled, .btn-close.disabled {\n  pointer-events: none;\n  user-select: none;\n  opacity: 0.25;\n}\n\n.modal-header .btn-close {\n  padding: 0.5rem 0.5rem;\n  margin: -0.5rem -0.5rem -0.5rem auto;\n}\n\n/* Global card styling */\n.card {\n  box-shadow: none !important;\n  border: 1px solid #e3ebf6 !important;\n  border-radius: 12px !important;\n}\n\n/* Hide spin buttons / up & down arrows on number inputs */\ninput[type=\"number\"]::-webkit-outer-spin-button,\ninput[type=\"number\"]::-webkit-inner-spin-button,\n.no-spinner::-webkit-outer-spin-button,\n.no-spinner::-webkit-inner-spin-button,\n.no-spinner input::-webkit-outer-spin-button,\n.no-spinner input::-webkit-inner-spin-button {\n  -webkit-appearance: none !important;\n  appearance: none !important;\n  margin: 0 !important;\n}\n\ninput[type=\"number\"],\n.no-spinner[type=\"number\"],\n.no-spinner input[type=\"number\"] {\n  -moz-appearance: textfield !important;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
